import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import BrandMarks from "./BrandMarks";

const LINKS = [
  ["/",               "Home"],
  ["/about",          "About"],
  ["/working-in-png",  "Working in PNG"],
  ["/opportunities",   "Business Opportunities"],
  ["/apply",           "Apply / Register"],
];

export default function Navbar({ isAdmin, onLogout }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate  = useNavigate();
  const location  = useLocation();

  const go = path => {
    navigate(path);
    setMenuOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const isOn = path =>
    path === "/" ? location.pathname === "/" : location.pathname.startsWith(path);

  return (
    <nav className="nav">
      <div className="nav-brand" onClick={() => go("/")}>
        <BrandMarks/>
        <div className="nav-brand-txt">
          <div className="t1">Korea Papua LNG</div>
          <div className="t2">Korean Workforce &amp; Business Portal</div>
        </div>
      </div>

      <button
        className={`nav-hamburger${menuOpen ? " open" : ""}`}
        onClick={() => setMenuOpen(o => !o)}
        aria-label="Toggle menu"
      >
        <span/><span/><span/>
      </button>

      <div className={`nav-links${menuOpen ? " open" : ""}`}>
        {LINKS.map(([path, label]) => (
          <button key={path} className={`nl${isOn(path) ? " on" : ""}`} onClick={() => go(path)}>
            {label}
          </button>
        ))}
        {isAdmin
          ? <button className="nav-cta out" onClick={() => { onLogout(); setMenuOpen(false); navigate("/"); }}>Sign Out</button>
          : <button className="nav-cta" onClick={() => go("/login")}>Admin</button>
        }
      </div>
    </nav>
  );
}
